export const Source = Object.freeze({
    js: 'js', // Web Site Javascript
    capi: 'capi', // Offline Events
    sftp: 'sftp', // SFTP Source
    upload: 'upload', // File Upload
    zoho: 'zoho', // Zoho CRM
    hub: 'hub', // Hubspot CRM
    spreadsheet: 'spreadsheet', // Google Spreadsheet
    ftp: 'ftp', // FTP Source
    androidcapi: 'androidcapi', // App Capi for Android
    ioscapi: 'ioscapi', // App Capi for IOS
    freshsales: 'freshsales', // Freshsales CRM
    dynamics: 'dynamics', // Microsoft Dynamics 365 CRM
    salesforce: 'salesforce', // Salesforce CRM
    monday: 'monday', // Monday CRM
    zendesk_sell: 'zendesk_sell', // Zendesk Sell CRM
    vtiger: 'vtiger', // Vtiger CRM
    odoo: 'odoo', // Odoo CRM
    pipe: 'pipe', // Pipedrive CRM
    bigquery: 'bigquery', // Google BigQuery
    appsflyer: 'appsflyer', // AppsFlyer
    lsqrd: 'lsqrd', // LeadSquared
    redirect: 'redirect', // Link Event
    b24: 'b24', // Bitrix 24
    adjust: 'adjust', // Adjust
});
